export default __webpack_public_path__ + "static/media/youtubeimg.4ddce29b.jpg";